import * as yup from 'yup';

export const checkoutSchema = yup.object().shape({
  alias_id: yup.string().required('Este campo é obrigatório.'),
  orders_quantity: yup.string().required('Este campo é obrigatório.'),
});
